export enum ProjectsActionTypes {
  PROJECTS_REQUESTED = "PROJECTS_REQUESTED",
  PROJECTS_SUCCESSFUL = "PROJECTS_SUCCESSFUL",
  PROJECTS_FAILED = "PROJECTS_FAILED",

  PROJECTS_METADATA_REQUESTED = "PROJECTS_METADATA_REQUESTED",
  PROJECTS_METADATA_SUCCESSFUL = "PROJECTS_METADATA_SUCCESSFUL",
  PROJECTS_METADATA_FAILED = "PROJECTS_METADATA_FAILED",

}
